import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "sidebar" */ './components/sidebar-desktop')
);

const Sidebar = props => <LoadableComponent {...props} />;

export default Sidebar;
